import React from 'react';
import { api } from '../util/api';
import { API_URL } from './urls';

export const uploadResume = async (file, data) => {
  let formData = new FormData();

  formData.append('resume', file);
  formData.append('resumeObj', JSON.stringify({ resumeName: data?.resumeName, status: false }));

  const options = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const result = await api.post(API_URL.RESUME_COVER_LETTER.UPLOAD_RESUME, formData, options);

  return result ? result : null;
};
export const resumeMatch = async data => {
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
    baseURL: `${process.env.NEXT_PUBLIC_REACT_APP_EMPLOYER_API_URL}`,
  };

  const result = await api.post(API_URL.RECRUITER.RESUME_MATCH, data, options);

  return result && result.data && result.httpStatus !== 500 ? result : null;
};

export const getResumes = async () => {
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const result = await api.get(API_URL.RESUME_COVER_LETTER.GET_RESUMES, options);
  return result;
};
